/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Complexe = require('../types/Complexe')
const Ope = require('../types/Ope')
const CCbGlob = require('../kernel/CCbGlob')
const CConstante = require('./CConstante')
const CConstantei = require('./CConstantei')
const CMoinsUnaire = require('./CMoinsUnaire')
const CResultatValeur = require('./CResultatValeur')
const COp = require('./COperation')

module.exports = CResultatValeurComplexe

/**
 * Classe représentant le résultat d'un calcul ou d'une mesure complexe existant.
 * @constructor
 * @extends CResultatValeur
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CValDyn} valeurAssociee : La valeur complexe dont c'est le résultat.
 * @returns {CResultatValeurComplexe}
 */
function CResultatValeurComplexe (listeProprietaire, valeurAssociee) {
  CResultatValeur.call(this, listeProprietaire);
  if (arguments.length !== 1) this.valeurAssociee = valeurAssociee;
}
CResultatValeurComplexe.prototype = new CResultatValeur();
CResultatValeurComplexe.prototype.constructor = CResultatValeurComplexe;
CResultatValeurComplexe.prototype.superClass = "CResultatValeur";
CResultatValeurComplexe.prototype.className = "CResultatValeurComplexe";

CResultatValeurComplexe.prototype.nature = function() {
  return CCbGlob.natResultatValeurComplexe;
};
CResultatValeurComplexe.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.valeurAssociee);
  return new CResultatValeurComplexe(listeCible, listeCible.get(ind1, "CValDyn"));
};
CResultatValeurComplexe.prototype.resultatComplexe = function(infoRandom, zRes) {
  // this.valeurAssociee.rendValeurComplexe(infoRandom, zRes);
  this.valeurAssociee.rendValeurComplexe(zRes);
};
CResultatValeurComplexe.prototype.calculAvecValeursRemplacees = function() {
  var z = new Complexe();
  this.valeurAssociee.rendValeurComplexe(z);
  var x = z.x;
  var y = z.y;
  var xcal, ycal;
  if (x >= 0) xcal = new CConstante(this.listeProprietaire, x);
  else xcal= new CMoinsUnaire(this.listeProprietaire, new CConstante(this.listeProprietaire, Math.abs(x)));
  if (y >= 0) ycal = new CConstante(this.listeProprietaire, y);
  else ycal= new CMoinsUnaire(this.listeProprietaire, new CConstante(this.listeProprietaire, Math.abs(y)));
  if (y === 0) return xcal;
  if (x===0) return new COp(this.listeProprietaire, ycal, new CConstantei(this.listeProprietaire), Ope.Mult) ;
  return new COp(this.listeProprietaire, xcal, new COp(this.listeProprietaire, ycal,
    new CConstantei(this.listeProprietaire), Ope.Mult), Ope.Plus);
};
